import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import leftArrow from '../assets/icon_left_arrow.png'

const ModalConfirm = ({confirmIsOpen, accept, code, iframe, back, term_condition_ocash, term_condition_opay}) => {
	return (
		<Modal className="modal-confirmation modal-term" isOpen={confirmIsOpen} backdrop='static' toggle={() => accept()} fade={false} >
		<ModalBody>
			<nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light">
				<div className="col-12" style={{padding: '0'}}>
						<div className="row">
							<div className="col-2" style={{paddingLeft: '15px', textAlign: 'start'}}>
								<img src={leftArrow} style={{width: '1.2rem', height: '1.3rem', verticalAlign: 'text-top'}} onClick={() => back()} alt=""/>
							</div>
							<div className="col-8 text-center" style={{fontSize: '1rem', fontWeight: '500'}}>
								Syarat dan Ketentuan
							</div>
							<div className="col-2"></div>
						</div>
				</div>
			</nav>  
			<div className="term-iframe">
				<div dangerouslySetInnerHTML={iframe} />
				{/* <div className="col-12">
						<button className="btn btn-primary btn-block2" onClick={() => accept(code)}>Aktifkan</button>
				</div> */}
			</div>
			<div className="check-box-yes">
				{ code === 'opay' ?
				// <div className="check-box-yes">
					<div className="form-group form-check d-flex align-items-center mb-0">
						<input type="checkbox" className="form-check-input mt-0" id="term_condition_opay" 
							checked={term_condition_opay} 
							onChange={(e) => accept(code)}/>
						<label className="small" 
						// onClick={(e) => accept(code)}
						style={{textAlign: 'left', fontSize: '80%', padding: '0.4em 0.3em', height: '55px'}}>
							Saya telah membaca dan setuju dengan Syarat {`&`}&nbsp;Ketentuan
							OttoPay yang berlaku.</label>
					</div>
				// </div>
				:
				// <div className="check-box-yes">
					<div className="form-group form-check d-flex align-items-center mb-0">
						<input type="checkbox" className="form-check-input mt-0" id="term_condition_ocash" 
							checked={term_condition_ocash} 
							onChange={(e) => accept(code)}/>
						<label className="small" 
						// onClick={(e) => accept(code)}
						style={{textAlign: 'left', fontSize: '80%', padding: '0.4em 0.3em', height: '55px'}}>
							Saya telah membaca dan setuju dengan Syarat {`&`}&nbsp;Ketentuan
							OttoCash yang berlaku.</label>
					</div>
				// </div>
				}
			</div>
			
	
		</ModalBody>
		{/* <ModalFooter>
			<div className="check-box-yes">
				{ code === 'opay' ?
				// <div className="check-box-yes">
					<div className="form-group form-check d-flex align-items-center mb-0">
						<input type="checkbox" className="form-check-input mt-0" id="term_condition_opay" 
							checked={term_condition_opay} 
							onChange={(e) => accept(code)}/>
						<label className="small" htmlFor="term_condition_opay" style={{textAlign: 'left', fontSize: '80%', padding: '0.4em 0.3em', height: '55px'}}>
							Saya telah membaca dan setuju dengan <label className="text-danger" htmlFor="term_condition_opay">Syarat {`&`} &nbsp;</label>
							<label className="text-danger">Ketentuan </label> 
							&nbsp; OttoPay yang berlaku.</label>
					</div>
				// </div>
				:
				// <div className="check-box-yes">
					<div className="form-group form-check d-flex align-items-center mb-0">
						<input type="checkbox" className="form-check-input mt-0" id="term_condition_ocash" 
							checked={term_condition_ocash} 
							onChange={(e) => 
							accept(code)}/>
						<label className="small" htmlFor="term_condition_ocash" style={{textAlign: 'left', fontSize: '80%', padding: '0.4em 0.3em', height: '55px'}}>
							Saya telah membaca dan setuju dengan <label className="text-danger" htmlFor="term_condition_ocash">Syarat {`&`} &nbsp;</label>
							<label className="text-danger">Ketentuan </label> 
							&nbsp; OttoCash yang berlaku.</label>
					</div>
				// </div>
				}
			</div>
		</ModalFooter> */}
		</Modal>
	);
}

export default ModalConfirm
